export const themes = {
  default: {
    thRoot: 'bg-white',
    thCloseButton:
      'reset-button bg-white cursor-pointer leading-none m-5 p-4 rounded-full text-gray-darker text-md',
    thCloseButtonLabel: 'a11y',
  },
};

export const POSITIONS_CLASSES = {
  top: {
    pin: 'inset-x-0 top-0',
    transform: '-translate-y-100',
    style: { maxHeight: 'calc(100% - 100px)' },
    button: 'bottom-0 right-0 rtl:slideInRight',
  },
  bottom: {
    pin: 'inset-x-0 bottom-0',
    transform: 'translate-y-100',
    style: { maxHeight: 'calc(100% - 100px)' },
    button: 'top-0 right-0 rtl:slideInRight',
  },
  left: {
    pin: 'inset-y-0 left-0',
    transform: '-translate-x-100',
    style: { maxWidth: 'calc(100vw - 100px)' },
    button: 'top-0 right-0',
  },
  right: {
    pin: 'inset-y-0 right-0',
    transform: 'translate-x-100',
    style: { maxWidth: 'calc(100vw - 100px)' },
    button: 'top-0 left-0',
  },
};
